export const PROVIDER = {
  GOOGLE: 'Google',
  // FACEBOOK: 'Facebook',
  APPLE: 'Apple',
  PAYPAL: 'PayPal'
}
